/**
 * 当前 L7 内部存在的地图版本
 */
export var Version;

(function (Version) {
  Version["GAODE1.x"] = "GAODE1.x";
  Version["GAODE2.x"] = "GAODE2.x";
  Version["MAPBOX"] = "MAPBOX";
  Version["L7MAP"] = "L7MAP";
  Version["SIMPLE"] = "SIMPLE";
  Version["GLOBEL"] = "GLOBEL";
})(Version || (Version = {}));